import { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { Item, SuccessPopUp, SuccessPopUp1, successPopUpKeyDown } from '../../common/snippets'
import { Box, Button, Paper, Radio, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import LineInput from '../../common/lineinput'
import * as iid from '../../common/bookingElementId'
import {
  getCmnLRDataForAdminUpdate,
  updateAlert,
  updateModal,
  setAdminUpdateCommonLrData,
  getLrStatusForCancelTransaction,
  LRRollBackUpdate,
  MarkAsLost,
  getVehicleList,
  getCityList,
  CancelReceive,
  getCancelTransfer,
  getBranchListForAdminUpdate,
  getUpdateTransfer,
  CancelBranchTransferReceive,
  BookingUpdate,
  GetLRForModifyUpdate,
} from '../../../store/common/common_action'
import Modal from '../../common/modal'
import TabPopup from './TabPopup'
import * as mdt from '../../../components/common/modaltypes'
import { LrTrackCard } from '../../lrSearch/lrTrackCard'
import { cancelDIspatch, updateDispatch } from '../../../store/cargoDispatch/dispatch_actions'
import { getOwnChildBranches } from '../../../store/reports/reports_action'
import { activeClassForLr, focusElemnt, isEmpty, isNull, navigation1, navigation2 } from '../../common/helper'
import { CargoRoleRightsAtom, companySettingsAtom, luggageSendOTP } from '../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
const paymentTypeColor = [
  { color: '#d1f5d3', value: 'PAID' },
  { color: '#e2e3f3', value: 'ON-ACCOUNT' },
  { color: '#ffe0bd', value: 'TO-PAY' },
  { color: '#c3f8ff', value: 'SELF' },
  { color: '#ffd8e5', value: 'COD' },
  { color: '#BDE1E1', value: 'FOC' },
  { color: '#fffdaf', value: 'TOPAY(DDDV)' },
]
const searchBy = [
  { id: 1, name: 'LR Number' },
  { id: 2, name: 'Manual LR Number' },
  { id: 3, name: 'Challan Number' },
  { id: 4, name: 'Sender Mobile Number' },
  { id: 5, name: 'Receiver Mobile Number' },
]
const senderReceiverDetailsUpdate = { id: 1, name: 'Sender Receiver Details Update' }
const ewayBillUpdate = { id: 2, name: 'E-Way Bill Update' }
const bookingDeliveryChargesUpdate = { id: 3, name: 'Booking / Delivery Charges Update' }
const cancelEditTransaction = { id: 4, name: 'Cancel / Edit Transaction' }
const rollBack ={ id: 5, name: 'Roll Back' }
const markAsLost = { id: 6, name: 'Mark As Lost' }
const consignmentBookingChargesUpdate = { id: 7, name: 'Consignment / Booking Charges Update' }

const AdminUpdate = (props) => {
  const {
    data: { common, reports },
    updateModal,
    getCmnLRDataForAdminUpdate,
    updateAlert,
    setAdminUpdateCommonLrData,
    getLrStatusForCancelTransaction,
    LRRollBackUpdate,
    MarkAsLost,
    getVehicleList,
    getCityList,
    cancelDIspatch,
    CancelReceive,
    getCancelTransfer,
    getBranchListForAdminUpdate,
    updateDispatch,
    getOwnChildBranches,
    getUpdateTransfer,
    CancelBranchTransferReceive,
    BookingUpdate,
    GetLRForModifyUpdate,
  } = props
  const {
    loginData,
    showModal,
    modalType,
    lrStatusCancelTransaction,
    vehicleList,
    cityList,
    adminBranchList,
  } = common
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const [companySettings] = useAtom(companySettingsAtom)
  const { AdminUpdateCommonLrData = [] } = common
  const { UseToPayAsCOD = 0 } = companySettings


  const [adminUpdateVisibility, setAdminUpdateVisibility] = useState(false)
  const [selectedRadio, setSelectedRadio] = useState('adminUpdate')
  const [senderSectContent, setSenderSectContent] = useState(0)
  const [lrNumber, setLrNumber] = useState('')
  const [selectLr, setSelectLr] = useState('')
  const [insuranceAmt, setInsuranceAmt] = useState(0)
  const [comment, setComment] = useState('')
  const [reset, setReset] = useState(false)
  const [selectedAction, setSelectedAction] = useState('')
  const [userOTP, setUserOtp] = useState()
  const [otpFor, setOtpFor] = useState('')
  const [dataForCanDispatch, setDataForCanDispatch] = useState()
  const [dataForMarkAsLost, setDataForMarkAsLost] = useState()
  const [dataForCanReceive, setDataForCanReceive] = useState()
  const [dataForCanBranchTransfer, setDataForCanBranchTransfer] = useState()
  const [dataForCanBranchTransferReceive, setDataForCanBranchTransferReceive] = useState()
  const [dataForUpdateDispatch, setDataForUpdateDispatch] = useState()
  const [dataForUpdateBooking, setDataForUpdateBooking] = useState()
  const [bookingDetails, setBookingDetails] = useState()
  const [dispatchDetails, setDispatchDetails] = useState()
  const [dataForUpdateBranchTransfer, setDataForUpdateBranchTransfer] = useState()
  const [branchTransferDetails, setBranchTransferDetails] = useState()
  const [branchList, setBranchList] = useState([])
  const [otperror, setOtpError] = useState(false)
  const [lrTrackingPopup, setLrTrackingPopup] = useState(false)
  const [selSearchBy, setSelSearchBy] = useState({
    id: 1,
    name: 'LR Number',
  })
  const [otpPopupVisible, setOtpPopupVisible] = useState(false)
  const [otpInfo, setOtpInfo] = useState({
    error: false,
    otpp: '',
    status: null,
  })
  const [actionData, setActionData] = useState([])
  const LrTrackData = lrStatusCancelTransaction?.Data?.Table
  const [successModal, setSuccessModal] = useState({
    success: { id: 'success', lrListLabel: ' rollback Popup Model' },
    markAsLostSuccess: { id: 'markAsLost', lrListLabel: ' mark As Lost Popup Model' },
    senRecDetailChange: { id: 'senRecDetailChange', lrListLabel: ' rollback Popup Model' },
  })

  useEffect(() => {
    if (!isEmpty(roleRights)) {
      let data = []
      const obj = roleRights?.Table1?.[0] || {}
      const obj1 = roleRights?.Table
      const foundObject = obj1?.find((obj) => obj.BookingRightsID === 12)
      if (obj.AllowRollBack === 1 || obj.AllowAdminCancelDispatch === 1 || obj.AllowAdminCancelReceive === 1 || obj.AllowAdminDispatchChange === 1 || obj.AllowAdminDestinationChange === 1 || obj.AllowAdminSendAndRecChange === 1) {
        if (obj?.AllowAdminSendAndRecChange == 1) {
          data.push(senderReceiverDetailsUpdate)
        }
        if (foundObject?.Allowed === 1) {
          data.push(ewayBillUpdate)
        }
        if (obj?.AllowAdminCancelDispatch == 1 || obj?.AllowAdminCancelReceive == 1) {
          data.push(cancelEditTransaction)
        }
        if (companySettings?.IsShowAdditional == 1 && roleRights?.Table1?.[0]?.AllowShowAdditional == 1) {
          data.push(bookingDeliveryChargesUpdate)
        }
        if (obj?.AllowRollBack == 1) {
          data.push(rollBack)
        }
        if (obj?.AllowMarkAsLost === 1) {
          data.push(markAsLost)
        }
        setSelectedRadio("adminUpdate")
        setAdminUpdateVisibility(true)
      } else if (companySettings?.IsShowAdditional == 1 && obj.AllowShowAdditional == 1) {
        if (obj?.AllowAdminSendAndRecChange == 1) {
          data.push(senderReceiverDetailsUpdate)
        }
        if (foundObject?.Allowed === 1) {
          data.push(ewayBillUpdate)
        }
        data = [...data, consignmentBookingChargesUpdate]
        setSelectedRadio("modify")
      } else {
        if (obj?.AllowAdminSendAndRecChange == 1) {
          data.push(senderReceiverDetailsUpdate)
        }
        setSelectedRadio("showLr")
      }
      setActionData(data)
    }
  }, [roleRights])
  useEffect(() => {
    if (loginData !== null) {
      getVehicleList(loginData)
      getCityList(loginData)
      if (loginData?.intCompanyID === 10) {
        const branchData = {
          intUserID: loginData?.intUserID,
          intCompanyID: loginData?.intCompanyID,
          intIsActive: 1,
        }
        getOwnChildBranches(branchData)
      }
    }
  }, [loginData])


  useEffect(() => {
    if (AdminUpdateCommonLrData.length > 0) {
      setSelectLr(AdminUpdateCommonLrData[0])
      focusElemnt('checkbox_' + AdminUpdateCommonLrData[0].BookingID)
    }
  }, [AdminUpdateCommonLrData.map((obj) => obj.BookingID).join(',')])
  const onClosePopup = () => {
    handleAlert(false)
    window.location.reload()
    if (AdminUpdateCommonLrData.length > 0) {
      setSelectLr(AdminUpdateCommonLrData[0])
      focusElemnt('checkbox_' + AdminUpdateCommonLrData[0].BookingID)
    }
  }
  useEffect(() => {
    setAdminUpdateCommonLrData([])
    setLrNumber('')
    focusElemnt(iid.selectInput)
  }, [selectedRadio])
  useEffect(() => {
    setAdminUpdateCommonLrData([]) //default list should be blank
    focusElemnt(iid.selectInput)
    //IsCompanyAdminUser todo
    // const obj = roleRights?.Table1
    // if (obj?.length > 0) {
    //   if (
    //     obj[0].AllowRollBack === 1 ||
    //     obj[0].AllowAdminCancelDispatch === 1 ||
    //     obj[0].AllowAdminCancelReceive === 1 ||
    //     obj[0].AllowAdminDispatchChange === 1 ||
    //     obj[0].AllowAdminDestinationChange === 1 ||
    //     obj[0].AllowAdminSendAndRecChange === 1
    //   ) {
    //     setAdminUpdateVisibility(true)
    //   } else {
    //     setAdminUpdateVisibility(false)
    //     setSelectedRadio('modify')
    //   }
    // }
    // //condition for rollback action visibility based on rolerights
    // if (obj?.length > 0) {
    //   if (obj[0].AllowRollBack === 1) {
    //     setRollbackVisible(true)
    //   }
    // }
    // //condition for EwayBill action visibility based on rolerights
    // const obj1 = roleRights?.Table
    // const foundObject = obj1?.find((obj) => obj.BookingRightsID === 12)
    // if (foundObject?.Allowed === 1) {
    //   setEWayBillVisible(true)
    // }
  }, [roleRights])
  const SelectLrForTracking = () => {
    getLrStatusForCancelTransaction(loginData, selectLr?.BookingID)
    // updateModal(true, mdt.lrTrackingPopup)
    setLrTrackingPopup(true)
  }
  const SelectLrForOtpValidation = (type, typeData = {},data2) => {
    const {DisableOTP=0} = selectLr||{}
    if(DisableOTP){
      otpValidation(type, typeData,data2,true)
    }else{
      setOtpFor(type)
      const data = {
        StrEventType: type,
        intCompanyID: loginData.intCompanyID,
        intUserID: loginData.intUserID,
        strContactNo: undefined,
        intBookingID: selectLr.BookingID,
        intMode: 1,
      }
      luggageSendOTP(data).then((res) => {
        if (res.Status) {
          setOtpPopupVisible(true)
          setOtpInfo({ otpp: res.OTP, status: res.Status, error: res.ErrMessage })
          updateModal(true, mdt.otpPopup)
        } else {
        //TODO:show alert error here
        }
      })
    }
  }

  const SelectLrForMarkAsLost = () => {
    const data = {
      Mode: 0,
      BookingID: selectLr?.BookingID,
      UserID: loginData.intUserID,
      LostRemarks: comment,
      InsuranceAmount: insuranceAmt,
    }
    MarkAsLost(data, onClosePopup, 'Success')
    updateModal(false)
    Search_Lr_Click() //updtae List screen data
  }
  const handleChange = (e) => {
    setSelectedRadio(e.target.value)
    let data = []
    const obj = roleRights?.Table1?.[0] || {}
    const obj1 = roleRights?.Table
    const foundObject = obj1?.find((obj) => obj.BookingRightsID === 12)
    if (e.target.value == "adminUpdate") {
      if (obj?.AllowAdminSendAndRecChange == 1) {
        data.push(senderReceiverDetailsUpdate)
      }
      if (foundObject?.Allowed === 1) {
        data.push(ewayBillUpdate)
      }
      if (obj?.AllowAdminCancelDispatch == 1 || obj?.AllowAdminCancelReceive == 1) {
        data.push(cancelEditTransaction)
      }
      if (companySettings?.IsShowAdditional == 1 && roleRights?.Table1?.[0]?.AllowShowAdditional == 1) {
        data.push(bookingDeliveryChargesUpdate)
      }
      if (obj?.AllowRollBack == 1) {
        data.push(rollBack)
      }
      data.push(markAsLost)
    } else if (e.target.value == "modify") {
      if (obj?.AllowAdminSendAndRecChange == 1) {
        data.push(senderReceiverDetailsUpdate)
      }
      if (foundObject?.Allowed === 1) {
        data.push(ewayBillUpdate)
      }
      data = [...data, consignmentBookingChargesUpdate]
    } else {
      if (obj?.AllowAdminSendAndRecChange == 1) {
        data.push(senderReceiverDetailsUpdate)
      }
    }
    setSelectedAction('')
    setActionData(data)
  }
  const handleChangeLr = (e) => {
    setLrNumber(e.target.value)
  }
  const RollBackPopup = () => {
    const data = {
      headTxt: 'Roll Back',
      successMessage: 'Do you want to Roll Back this LR Number?',
      // otherMessage: '',
      buttonId1: 'deliveryyes',
      buttonId2: '',
      yesAction: () => {
        SelectLrForOtpValidation('RollBack')
      },
      noAction: () => updateModal(false),
    }
    return <SuccessPopUp data={data} updateModal={updateModal} />
  }
  const OtpPopupUI = () => {
    return (
      <Modal headTxt={`Submit OTP`} width={'25%'} updateModal={props.updateModal}>
        <Stack>
          <Box sx={{ width: '100%', display: 'inline-flex', padding: '0% 0px' }}>
            <div className={'input--wrapper'} style={{ width: '100%', marginLeft: '12px', marginRight: '8px', marginTop: '15px' }}>
              <LineInput
                id={`Enter_OTP`}
                label={`Enter OTP`}
                width="11%"
                type="text"
                name="Enter_OTP"
                value={userOTP || ''}
                autoFocus={true}
                onChange={(e) => otpHandleChange(e)}
                lg={{ margin: '8px', width: '100%' }}
                onKeyDown={(e) => navigation1(e, `SubmitButton`, '')}
              />
            </div>
          </Box>
          {otperror ? (
            <Box style={{ marginLeft: '13px', marginTop: '0px' }}>
              <span style={{ color: 'red', fontSize: '13px' }}>Please enter valid OTP</span>{' '}
            </Box>
          ) : (
            ''
          )}
          <Box>
            <span
              style={{ fontSize: '13px', fontWeight: '700', color: 'blue', cursor: 'pointer', marginLeft: '145px' }}
              onClick={() => resendOTP(otpFor)}
            >
              Resend OTP
            </span>
          </Box>
        </Stack>
        <Stack>
          <div>
            <Box style={{ margin: '15px 0px', marginLeft: '12px', marginRight: '8px' }}>
              <Button
                id={`SubmitButton`}
                variant="contained"
                color="error"
                style={{ width: '100%', padding: '10px', fontSize: '13px' }}
                onClick={(e) => {
                  otpValidation(otpFor)
                }}
              >
                Submit
              </Button>
            </Box>
          </div>
        </Stack>
      </Modal>
    )
  }
  const MarkAsLostPopup = () => {
    return (
      <>
        <Modal headTxt={`Mark As Lost`} width={'30%'} updateModal={updateModal}>
          <Stack direction="column" sx={{ padding: '15px 0px', fontSize: '15px' }}>
            <div style={{ width: '100%', padding: '0px 15px', position: 'relative' }}>
              <div
                style={{
                  display: `flex`,
                  flexWrap: `wrap`,
                  justifyContent: 'space-between',
                }}
              >
                <Box
                  sx={{
                    width: '99%',
                    display: 'inline-flex',
                    padding: '0% 0px',
                  }}
                >
                  <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                    <LineInput
                      // id={iid.ewaybillNoInput}
                      type={`number`}
                      name={`ewaybillNo`}
                      label={`Insurance Amount`}
                      value={insuranceAmt}
                      autoFocus={true}
                      onChange={(e) => {
                        setInsuranceAmt(e.target.value)
                      }}
                      onKeyDown={(e) => navigation1(e, `comment`, '')}
                    />
                  </div>
                </Box>
                <Box
                  sx={{
                    width: '99%',
                    display: 'inline-flex',
                    padding: '0% 0px',
                  }}
                >
                  <div className={'input--wrapper small_space'} style={{ width: '100%' }}>
                    <LineInput
                      id={`comment`}
                      type={`text`}
                      name={`ewaybillNo`}
                      label={`Mark as lost comment`}
                      value={comment}
                      onChange={(e) => {
                        setComment(e.target.value)
                      }}
                      row={4}
                      onKeyDown={(e) => navigation1(e, `markLostButton`, `comment`)}
                    />
                  </div>
                </Box>

                <div className="input--wrapper small_space" style={{ padding: '8px', width: '50%', textAlign: 'end' }}>
                  <Button
                    className="btn cancel-btn"
                    variant="outlined"
                    color="error"
                    // ref={`cancelButton`}
                    onClick={() => {
                      updateModal()
                      setComment('')
                      setInsuranceAmt(0)
                    }}
                  >
                    CANCEL
                  </Button>
                </div>
                <div className="input--wrapper small_space" style={{ padding: '8px', width: '50%' }}>
                  <Button
                    id={`markLostButton`}
                    //  ref={`markLostButton`}
                    className="btn btn-primary"
                    variant="contained"
                    color="error"
                    style={{ backgroundColor: '#fe5200', fontSize: '1.36rem' }}
                    onClick={() => {
                      SelectLrForMarkAsLost()
                    }}
                  >
                    MARK AS LOST
                  </Button>
                </div>
              </div>
            </div>
          </Stack>
        </Modal>
      </>
    )
  }
  // else if (selectLr?.Status === 'Lost') {
  //   handleAlert('Selected LRNO is Already Marked as Lost!')
  // }
  const handleGoClick = () => {
    // if (selectLr?.IsDelivered) {
    //   handleAlert('Selected LRNO is Already Delivered!')
    // }
    if (selectLr?.Status === 'DELIVERED' || selectLr?.Status === 'REFUND') {
      handleAlert('Selected LRNO is Already Delivered or Refunded!')
    } else {
      if (selectedAction === '') {
        handleAlert('Please Select Action!')
      } else {
        switch (selectedAction?.id) {
          case 1: {
            setSenderSectContent(0)
            updateModal(true, 'senRecDetailChange')

            break
          }
          case 2: {
            setSenderSectContent(1)
            updateModal(true, 'senRecDetailChange')
            break
          }
          case 3: {
            setSenderSectContent(2)
            updateModal(true, 'senRecDetailChange')
            break
          }
          case 7: {
            setSenderSectContent(2)
            const obj = {
              CompanyID: loginData.intCompanyID,
              BranchID: selectLr?.BookingBranchID,
              BookingID: selectLr?.BookingID,
            }
            GetLRForModifyUpdate(obj, props)
            updateModal(true, 'senRecDetailChange')
            break
          }
          case 4: {
            SelectLrForTracking()
            break
          }
          case 5: {
            updateModal(true, 'success')
            break
          }
          case 6: {
            updateModal(true, 'markAsLost')
            break
          }
          default:
            break
        }
      }
    }
  }
  const handleAlert = (msg = false, nextId = '') => {
    if (typeof msg === 'string' && !isNull(msg)) {
      updateAlert({ show: true, msg, nextId })
    } else {
      updateAlert({ show: false, msg: '', nextId: '' })
      focusElemnt(nextId)
    }
  }
  const Search_Lr_Click = () => {
    //lrNumber is lineInput
    let strlrno
    let isFullLr
    setSelectLr('')
    strlrno = lrNumber
    if (lrNumber == '') {
      handleAlert('Select ' + selSearchBy?.name + ' For Search')
    } else {
      if (selSearchBy.id === 1) {
        //0 will only appends if lrNumber length is less than 7 and it doesn't include any / or \
        isFullLr = lrNumber.includes('\\') || lrNumber.includes('/')
        if (lrNumber.length < 7 && !isFullLr) {
          strlrno = '0000000' + lrNumber
          strlrno = strlrno.substring(strlrno.length - 7)
        }
      }
      const obj = {
        CompanyID: loginData.intCompanyID,
        BranchID: loginData.intBranchID,
        UserID: loginData.intUserID,
        Mode: selSearchBy.id,
        //  Mode: strlrno.includes('/') || strlrno.includes('\\') ? 1 : selSearchBy.id,
        SearchValue: strlrno,
      }
      setAdminUpdateCommonLrData([])
      getCmnLRDataForAdminUpdate(obj,UseToPayAsCOD)
    }
  }
  const handleCancel = () => {
    updateModal()
    setLrNumber('')
  }
  const otpHandleChange = (e) => {
    setOtpError(false)
    setUserOtp(e.target.value)
  }
  const resendOTP = () => {
    setUserOtp('')
    setOtpError(false)
    const data = {
      StrEventType: otpFor,
      intCompanyID: loginData.intCompanyID,
      intUserID: loginData.intUserID,
      intBookingID: selectLr.BookingID,
      intMode: 1,
      strContactNo: undefined,
    }
    luggageSendOTP(data).then((res) => {
      if (res.Status) {
        setOtpPopupVisible(true)
        setOtpInfo({ otpp: res.OTP, status: res.Status, error: res.ErrMessage })
      } else {
      }
    }) 
  }
  const otpValidation = (type, typeData = {}, data2 = {}, skipOTP = false) => {
    if ((otpPopupVisible && otpInfo.otpp === userOTP) || otpPopupVisible === false || skipOTP) {
      setOtpError(false)
      setUserOtp('')
      if (type === 'RollBack') {
        const data = {
          BookingID: selectLr?.BookingID,
          UserID: loginData.intUserID,
          CompanyID: loginData.intCompanyID,
        }
        LRRollBackUpdate(data, onClosePopup) //api call
        Search_Lr_Click() //to update list Screen
      } else if (type === 'Cancel Dispatch') {
        const cancelData = {
          strBookingIDs: Object.keys(typeData).length === 0 ? dataForCanDispatch.BookingID : typeData.BookingID,
          strDispatchIDS: Object.keys(typeData).length === 0 ? dataForCanDispatch.DispatchDetID : typeData.DispatchDetID,
          intIsShortReceipt: 0,
          intUsreID: loginData.intUserID,
          strComments: '',
        }
        cancelDIspatch(cancelData, onClosePopup) //api call
        Search_Lr_Click() //to update list Screen
      } else if (type === 'Cancel Receive') {
        const cancelData = {
          BookingID: Object.keys(typeData).length === 0 ? dataForCanReceive.BookingID : typeData.BookingID,
          ReceiptDetID: Object.keys(typeData).length === 0 ? dataForCanReceive.ReceiptDetID : typeData.ReceiptDetID,
          UserID: loginData.intUserID,
        }
        CancelReceive(cancelData, onClosePopup) //api call for cancel receive
        Search_Lr_Click() //to update list Screen
      } else if (type === 'Cancel Branch Transfer') {
        const Canceldata = {
          strBookingIDs: Object.keys(typeData).length === 0 ? dataForCanBranchTransfer.BookingID : typeData.BookingID,
          strBranchTransferIDS: Object.keys(typeData).length === 0 ? dataForCanBranchTransfer.DispatchDetID : typeData.DispatchDetID,
        }

        getCancelTransfer(loginData, Canceldata, onClosePopup) //api call
        Search_Lr_Click() //to update list Screen
      } else if (type === 'Cancel Branch Transfer Receive') {
        const Canceldata = {
          BookingID: Object.keys(typeData).length === 0 ? dataForCanBranchTransferReceive.BookingID : typeData.BookingID,
          ReceiptDetID: Object.keys(typeData).length === 0 ? dataForCanBranchTransferReceive.ReceiptDetID : typeData.ReceiptDetID,
          UserID: loginData.intUserID,
        }

        CancelBranchTransferReceive(Canceldata, onClosePopup) //api call
        Search_Lr_Click() //to update list Screen
      } else if (type === 'Dispatch Update') {
        if (adminBranchList.length > 0) {
          const obj = {
            intDispatchID: typeData.DispatchDetID,
            strVehicleNo: data2.strVehicleNo,
            intToCityID: data2.intToCityID,
            intToBranchID: data2.intToBranchID,
            strRemarks: '',
            intVehicleID: data2.intVehicleID,
            intUserID: loginData.intUserID,
          }
          updateDispatch(obj, onClosePopup)
          Search_Lr_Click()
        } else {
          handleAlert('Selected City Does Not Having Branch!')
        }
      } else if (type === 'Booking Update') {
        if (adminBranchList.length > 0) {
          const obj = {
            CompanyID: loginData.intCompanyID,
            UserID: loginData.intUserID,
            BookingID: typeData.BookingID,
            DestinationCityID: data2.DestinationCityID,
            DestinationBranchID: data2.DestinationBranchID,
          }
          BookingUpdate(obj, onClosePopup) //api call
          Search_Lr_Click() //to update list Screen
        } else {
          handleAlert('Selected City Does Not Having Branch!')
        }
      } else if (type === 'Branch Transfer Update') {
        if (adminBranchList.length > 0) {
          const obj = {
            intBranchTransferDetID: typeData.DispatchDetID,
            intToCityID: data2.intToCityID,
            intToBranchID: data2.intToBranchID,
            intCompanyID: loginData?.intCompanyID,
            strVehicleType: 'SV',
            strVehicleNo: data2.strVehicleNo,
            strTransferReason: 'Transfer From Admin Update',
            strRemarks: '',
            intUserID: loginData?.intUserID,
            blnDeliveryTransfer: 0,
            intVehicleID: data2.intVehicleID,
            // intDriverID: 0,
          }
          getUpdateTransfer(obj, onClosePopup) //api call
          Search_Lr_Click() //to update list Screen
        } else {
          handleAlert('Selected City Does Not Having Branch!')
        }
      }
      setLrTrackingPopup(false)
      updateModal(false)
    } else if (type === 'Mark Lost') {
      const data = {
        Mode: 1,
        BookingID: typeData?.BookingID,
        UserID: loginData.intUserID,
        LostRemarks: '',
        InsuranceAmount: '',
      }
      MarkAsLost(data, onClosePopup, 'Cancel')
      Search_Lr_Click()
    } else {
      setOtpError(true)
    }
  }
  const handleCancelDispatch = (data) => {
    SelectLrForOtpValidation('Cancel Dispatch', data)
    setDataForCanDispatch(data)
  }
  const handleMarkedAsLost = (data) => {
    SelectLrForOtpValidation('Mark Lost',data)
    setDataForMarkAsLost(data)
  }
  const handleCancelReceive = (data) => {
    SelectLrForOtpValidation('Cancel Receive', data)
    setDataForCanReceive(data)
  }
  const handleCancelBranchTransfer = (data) => {
    SelectLrForOtpValidation('Cancel Branch Transfer', data)
    setDataForCanBranchTransfer(data)
  }
  const handleCancelBranchTransferReceive = (data) => {
    SelectLrForOtpValidation('Cancel Branch Transfer Receive', data)
    setDataForCanBranchTransferReceive(data)
  }
  const handleBranch = (cityId) => {
    // if (loginData?.intCompanyID === 10) {
    //   const brnchList = ownChildBranches.filter((e) => e.CityID === cityId)
    //   setBranchList(brnchList)
    // } else {
    const obj = {
      intUserID: loginData?.intUserID,
      intCompanyID: loginData?.intCompanyID,
      intCityID: cityId,
      intBookingBranchID: -1,
    }
    getBranchListForAdminUpdate(obj) //api call for get BranchList of dest City
    //}
  }
  const handleDispatchUpdate = (data, dispatchDetails) => {
    SelectLrForOtpValidation('Dispatch Update',data,dispatchDetails)
    setDataForUpdateDispatch(data)
    setDispatchDetails(dispatchDetails)
  }
  const handleBookingUpdate = (data, bookingDetails) => {
    SelectLrForOtpValidation('Booking Update',data,bookingDetails)
    setDataForUpdateBooking(data)
    setBookingDetails(bookingDetails)
  }
  const handleBranchTransferUpdate = (data, branchTransferDetails) => {
    SelectLrForOtpValidation('Branch Transfer Update',data,branchTransferDetails)
    setDataForUpdateBranchTransfer(data)
    setBranchTransferDetails(branchTransferDetails)
  }

  const LrTrackingPopupUI = () => {
    return (
      <Modal
        headTxt={`LR Tracking`}
        headText2={'LR Number: ' + selectLr?.LRNo}
        width={'25%'}
        height={'100%'}
        updateModal={() => {
          setLrTrackingPopup(false)
        }}
        modalClass="model--container-right"
        onCloseCallback={handleCancel}
      >
        <div
          role="tabpanel"
          // hidden={lrTabValue !== 1}
          id={`main-tabpanel-1`}
          aria-labelledby={`main-tab-1`}
          className="tab-main-2 details-container"
          style={{ height: 'calc(100% - 62px)', overflowX: 'auto' }}
        >
          {LrTrackData?.map((Item, index, arr) => {
            return (
              <LrTrackCard
                data={Item}
                key={'lrTrackCard' + index}
                lastStatus={arr[arr.length - 1]}
                isEditable="update"
                loginData={loginData}
                vehicleList={vehicleList}
                cityList={cityList} //vehicle List for dropdown
                // branchList={loginData?.intCompanyID === 10 ? branchList : adminBranchList}
                branchList={adminBranchList}
                visibilityFlag={roleRights?.Table1[0]}
                handleCancelDispatch={handleCancelDispatch} //cancelDispatch from LRTrackingScreen
                handleMarkedAsLost={handleMarkedAsLost}   // marked as lost
                handleCancelReceive={handleCancelReceive} //cancelDispatch from LRTrackingScreen
                handleCancelBranchTransfer={handleCancelBranchTransfer} //cancelBranchTransfer from LRTrackingScreen
                handleCancelBranchTransferReceive={handleCancelBranchTransferReceive} //cancelBranchTransferReceive from LRTrackingScreen
                handleBranch={handleBranch}
                handleDispatchUpdate={handleDispatchUpdate}
                handleBookingUpdate={handleBookingUpdate}
                handleBranchTransferUpdate={handleBranchTransferUpdate}
              />
            )
          })}
        </div>
      </Modal>
    )
  }
  return (
    <div style={{ position: 'absolute', width: '100%' }}>
      <Item sx={{ padding: '0' }} className="reports">
        <Box className="light-bg radio-wrap" sx={{ paddingLeft: '15px', paddingRight: '24px', display: 'flex' }}>
          <label htmlFor={'isCrossingRadioYes'} className="radio-label flex" style={{ display: adminUpdateVisibility ? '' : 'none' }}>
            <Radio
              id={'isCrossingRadioYes'}
              name={`isCrossingRadio`}
              size={'medium'}
              value="adminUpdate"
              checked={selectedRadio === 'adminUpdate'}
              onChange={handleChange}
            // hidden={true}
            />
            Admin Update
          </label>
          {
            companySettings?.IsShowAdditional == 1 && roleRights?.Table1?.[0]?.AllowShowAdditional == 1 ?
              <label htmlFor={'isCrossingRadioNo'} className="radio-label flex">
                <Radio
                  id={'isCrossingRadioNo'}
                  name={`isCrossingRadio`}
                  size={'medium'}
                  value="modify"
                  checked={selectedRadio === 'modify'}
                  onChange={handleChange}
                />
                Modify (Show Additional)
              </label>

              : null
          }
          {
            roleRights?.Table1?.[0]?.AllowAdminSendAndRecChange == 1 ?
              <label htmlFor={'isCrossingRadioNoShowLr'} className="radio-label flex">
                <Radio
                  id={'isCrossingRadioNoShowLr'}
                  name={`isCrossingRadio`}
                  size={'medium'}
                  value="showLr"
                  checked={selectedRadio === 'showLr'}
                  onChange={handleChange}
                />
                Show LR
              </label>
              : null
          }
        </Box>
        {
          adminUpdateVisibility || roleRights?.Table1?.[0]?.AllowAdminSendAndRecChange == 1 || (companySettings?.IsShowAdditional == 1 && roleRights?.Table1?.[0]?.AllowShowAdditional == 1) ?
            <Stack sx={{ minHeight: 100, minWidth: 650, marginTop: '8px' }}>
              <Box
                key={`for_otp_lnIp_`}
                sx={{
                  width: '99%',
                  marginLeft: '1%',
                  display: 'inline-flex',
                  padding: '0% 0px',
                }}
              >
                <Item sx={{ width: '25%' }}>
                  <DropDownOA
                    data={searchBy || []}
                    defaultvalue={searchBy?.[0]?.name}
                    //  value={selSearchBy?.name}
                    width="100%"
                    searchPlaceholder={'Search By'}
                    label={`Select Option Search By`}
                    isObjArr={true}
                    dataKey={`name`}
                    idKey={`id`}
                    tabIndex="5"
                    onSelect={(e) => {
                      setSelSearchBy(e)
                      setLrNumber('')
                      setAdminUpdateCommonLrData([])
                    }}
                    id={iid.selectSearchBy}
                    nextId={iid.selectInput}
                  />
                </Item>
                <Item sx={{ width: '25%' }}>
                  <div className={'input--wrapper'} style={{ marginBottom: '0px' }}>
                    <LineInput
                      id={iid.selectInput}
                      type="text"
                      label={selSearchBy?.name === 'Paid' ? 'LR Number' : selSearchBy?.name}
                      searchPlaceholder={'LR Number'}
                      value={lrNumber}
                      onChange={(e) => handleChangeLr(e)}
                      //  autoFocus={true}
                      onKeyDown={(e) => navigation2(e, iid.searchLrButton, iid.selectSearchBy)}
                    />
                  </div>
                </Item>
                <div className="input--wrapper small_space" style={{ padding: '8px', width: '11%' }}>
                  <Button
                    id={iid.searchLrButton}
                    className="select-lr-btn"
                    variant="contained"
                    color="error"
                    style={{ backgroundColor: '#fe5200', fontSize: '1.3rem' }}
                    onClick={Search_Lr_Click}
                  //  onKeyDown={(e) => {}}
                  >
                    SEARCH LR
                  </Button>
                </div>

                <div style={{ width: '1.29%', borderLeft: '2px solid black' }}></div>

                <Item sx={{ width: '25%' }}>
                  <DropDownOA
                    id={iid.selectAction}
                    // data={
                    //   selectedRadio === 'modify'
                    //     ? selectActionForModify
                    //     : selectedRadio === 'showLr'
                    //     ? selectActionForShowLr
                    //     : rollbackVisible
                    //     ? eWayBillVisible
                    //       ? selectAction
                    //       : selectActionWithoutEwayBill
                    //     : selectActionWithoutRollback
                    // }
                    defaultvalue={selectedAction?.name||""}
                    data={actionData || []}
                    width="105%"
                    searchPlaceholder={'Search By Action'}
                    label={`Select Action`}
                    isObjArr={true}
                    dataKey={`name`}
                    idKey={`id`}
                    tabIndex="5"
                    onSelect={(e) => {
                      setSelectedAction(e)
                      setReset(false)
                    }}
                    resetFlag={reset}
                    nextId={iid.goButton}
                  />
                </Item>
                <div className="input--wrapper small_space" style={{ padding: '8px', width: '11%', paddingLeft: '23px' }}>
                  <Button
                    id={iid.goButton}
                    className="select-lr-btn"
                    variant="contained"
                    color="error"
                    style={{ backgroundColor: '#fe5200', fontSize: '1.3rem' }}
                    onClick={handleGoClick}
                  >
                    Go
                  </Button>
                </div>
                <div className="input--wrapper small_space" style={{ padding: '8px', width: '16%' }}>
                  <Button
                    // id={iid.searchLrButton}
                    className="btn cancel-btn"
                    variant="outlined"
                    color="error"
                    onClick={(e) => {
                      setReset(true)
                      setSelectedAction('')
                    }}
                  >
                    Reset
                  </Button>
                </div>
              </Box>
            </Stack>
            : null
        }
      </Item>
      <div hidden={AdminUpdateCommonLrData?.length <= 0}>
        <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
          <TableContainer
            className="lr-popup-table lrModel"
            component={Paper}
            style={{
              height: '400px',
            }}
          >
            <Table className="table1" size="small" aria-label="a dense table">
              <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                <TableRow style={{ background: `#e5f3fa` }}>
                  <TableCell style={{ fontSize: '13px' }}>Select</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>LR No.</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>LR No. Format</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>LR No. Manual</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>LR No. Status</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Challan No.</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Payment Type</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Sender Name</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Sender Number</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Receiver Name</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Receiver Number</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Current Branch</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Source Branch</TableCell>
                  <TableCell style={{ fontSize: '13px' }}>Destination Branch</TableCell>
                </TableRow>
              </TableHead>

              <TableBody className="filter-data-row">
                {AdminUpdateCommonLrData?.map((item, index) => (
                  <TableRow
                    onClick={() => setSelectLr(item)}
                    key={index}
                    style={{ backgroundColor: item.BookingID == selectLr?.BookingID ? '#e5f3fa' : '' }}
                  >
                    <TableCell className="checkbox-ctrl" style={{ verticalAlign: 'bottom' }}>
                      <input
                        type="radio"
                        id={`checkbox_${item.BookingID}`}
                        checked={item.BookingID === selectLr?.BookingID ? true : false}
                        //onClick={() => setSelectLr(item)}
                        onChange={() => { }}
                        name="record"
                        onKeyDown={(e) => navigation2(e, iid.selectAction, `checkbox_${item.BookingID}`)}
                      />
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.LRNo}>
                        {item.LRNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.FormattedLRNO}>
                        {item.FormattedLRNO}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.ManualLRNo}>
                        {item.ManualLRNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.Status}>
                        {item.Status}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.VoucherNo}>
                        {item.VoucherNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span className={activeClassForLr(item.PaymentType)} title={item.PaymentType}>
                        {item.PaymentType}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px', width: '90px' }} title={item.Sender}>
                        {item.Sender}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.SenderMobileNo}>
                        {item.SenderMobileNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px', width: '90px' }} title={item.RecName}>
                        {item.RecName}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px' }} title={item.RecMobileNo}>
                        {item.RecMobileNo}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px', width: '90px' }} title={item.BookingBranchName}>
                        {item.BookingBranchName}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px', width: '90px' }} title={item.BookingBranchName}>
                        {item.BookingBranchName}
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ fontSize: '13px', width: '90px' }} title={item.DestinationBranchName}>
                        {item.DestinationBranchName}
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <Stack>
          <div className="modal-btn-grp" style={{ justifyContent: 'start', marginLeft: '1.7%' }}>
            <span style={{ display: 'flex', marginRight: '450px' }}>
              {paymentTypeColor.map((val, i) => {
                return (
                  <>
                    <span
                      style={{ marginLeft: '10px', backgroundColor: val.color, width: '13px', height: '13px', borderRadius: '50%' }}
                    ></span>
                    <span style={{ padding: '0px 7px', fontSize: '12px' }}>{val.value}</span>
                  </>
                )
              })}
            </span>
          </div>
        </Stack>
      </div>
      {showModal && [successModal.success.id].includes(modalType) && RollBackPopup(modalType == successModal.success.id)}
      {showModal &&
        [successModal.markAsLostSuccess.id].includes(modalType) &&
        MarkAsLostPopup(modalType == successModal.markAsLostSuccess.id)}
      {showModal && [successModal.senRecDetailChange.id].includes(modalType) && (
        <TabPopup
          senderSectContent={senderSectContent}
          setSenderSectContent={setSenderSectContent}
          lrDetail={selectLr}
          selectedRadio={selectedRadio}
          updateData={Search_Lr_Click}
          onClosePopup={onClosePopup}
        />
      )}
      {/* {showModal && mdt.lrTrackingPopup === modalType && LrTrackingPopupUI()} */}
      {lrTrackingPopup && LrTrackingPopupUI()}
      {showModal && mdt.otpPopup === modalType && OtpPopupUI()}
    </div>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  getCmnLRDataForAdminUpdate,
  updateAlert,
  setAdminUpdateCommonLrData,
  getLrStatusForCancelTransaction,
  LRRollBackUpdate,
  MarkAsLost,
  getVehicleList,
  getCityList,
  cancelDIspatch,
  CancelReceive,
  getCancelTransfer,
  getBranchListForAdminUpdate,
  updateDispatch,
  getOwnChildBranches,
  getUpdateTransfer,
  CancelBranchTransferReceive,
  BookingUpdate,
  GetLRForModifyUpdate,
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminUpdate)
